module.exports = __webpack_public_path__ + "img/duplicate.baa85b77.svg";